import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { alpha, useTheme } from '@mui/material/styles';
import { Accordion, AccordionSummary, AccordionDetails, Grid, Box, Button } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { SimTypography } from 'components/SimTypography';

const NavItem = ({ primeTabs, linkTreeFLAT }) => {
	const theme = useTheme();
	const [activeLink, setActiveLink] = useState('');
	useEffect(() => {
		setActiveLink(window && window.location ? window.location.pathname : '');
	}, []);

	const hasActiveLink = () => linkTreeFLAT.find(i => i.href === activeLink);

	return (
		<Box>
			<Grid container spacing={1}>
				{primeTabs.map((pPT, iPT) =>
					pPT.hasTabs === 1 ? (
						<Grid item key={iPT} xs={12}>
							<Accordion disableGutters elevation={0} sx={{ backgroundColor: 'transparent' }}>
								<AccordionSummary
									expandIcon={<ExpandMoreIcon />}
									aria-controls='panel1a-content'
									id='panel1a-header'
									sx={{ padding: 0 }}>
									<SimTypography
										variant={'menuRootText'}
										fontWeight={hasActiveLink() ? 600 : 400}
										color={hasActiveLink() ? 'primary' : 'text.primary'}>
										<Box paddingLeft={pPT.isTabLink === 1 ? 2 : 0}>{pPT.title} </Box>
									</SimTypography>
								</AccordionSummary>

								<AccordionDetails sx={{ padding: 0 }}>
									<Grid container spacing={1}>
										<Grid item xs={12}>
											<Button
												size={'large'}
												component={'a'}
												href={pPT.href}
												fullWidth
												sx={{
													justifyContent: 'flex-start',
													backgroundColor:
														activeLink === pPT.href
															? alpha(theme.palette.primary.main, 0.1)
															: 'transparent',
													fontWeight: activeLink === pPT.href ? 600 : 400
												}}>
												<SimTypography variant={'menuRootText'}>
													<Box
														paddingLeft={pPT.isTabLink === 1 ? 3 : 0}
														fullWidth
														sx={{
															justifyContent: 'flex-start',
															backgroundColor:
																activeLink === pPT.href
																	? alpha(theme.palette.primary.main, 0.1)
																	: 'transparent',
															fontWeight: activeLink === pPT.href ? 600 : 400,
															color: hasActiveLink() ? 'primary' : 'text.primary'
														}}>
														Overview
													</Box>
												</SimTypography>
											</Button>
										</Grid>

										{pPT.TabItems.map((pPT2, iPT2) =>
											pPT2.hasTabs === 1 ? (
												<Grid item key={iPT2} xs={12}>
													<Accordion
														disableGutters
														elevation={0}
														sx={{ backgroundColor: 'transparent' }}>
														<AccordionSummary
															expandIcon={<ExpandMoreIcon />}
															aria-controls='panel1a-content'
															id='panel1a-header'
															sx={{ padding: 0 }}>
															<SimTypography
																variant={'menuRootText'}
																fontWeight={hasActiveLink() ? 600 : 400}
																color={hasActiveLink() ? 'primary' : 'text.primary'}>
																<Box paddingLeft={pPT2.isTabLink === 1 ? 2 : 0}>
																	{pPT2.title}{' '}
																</Box>
															</SimTypography>
														</AccordionSummary>
														<AccordionDetails sx={{ padding: 0 }}>
															<Grid container spacing={1}>
																{pPT2.TabItems.map((pPT3, iPT3) =>
																	pPT3.hasTabs === 1 ? (
																		<Grid item key={iPT3} xs={12}>
																			<Accordion
																				disableGutters
																				elevation={0}
																				sx={{ backgroundColor: 'transparent' }}>
																				<AccordionSummary
																					expandIcon={<ExpandMoreIcon />}
																					aria-controls='panel1a-content'
																					id='panel1a-header'
																					sx={{ padding: 0 }}>
																					<SimTypography
																						variant={'menuRootText'}
																						fontWeight={
																							hasActiveLink() ? 600 : 400
																						}
																						color={
																							hasActiveLink()
																								? 'primary'
																								: 'text.primary'
																						}>
																						<Box
																							paddingLeft={
																								pPT3.isTabLink === 1
																									? 3
																									: 0
																							}>
																							{' '}
																							{pPT3.title}{' '}
																						</Box>
																					</SimTypography>
																				</AccordionSummary>
																				<AccordionDetails sx={{ padding: 0 }}>
																					<Grid container spacing={1}>
																						{pPT3.TabItems.map(
																							(pPT4, iPT4) =>
																								pPT4.hasTabs === 1 ? (
																									<Grid
																										item
																										key={iPT4}
																										xs={12}>
																										<Accordion
																											disableGutters
																											elevation={
																												0
																											}
																											sx={{
																												backgroundColor:
																													'transparent'
																											}}>
																											<AccordionSummary
																												expandIcon={
																													<ExpandMoreIcon />
																												}
																												aria-controls='panel1a-content'
																												id='panel1a-header'
																												sx={{
																													padding: 0
																												}}>
																												<SimTypography
																													variant={
																														'menuRootText'
																													}
																													fontWeight={
																														hasActiveLink()
																															? 600
																															: 400
																													}
																													color={
																														hasActiveLink()
																															? 'primary'
																															: 'text.primary'
																													}>
																													<Box
																														paddingLeft={
																															pPT4.isTabLink ===
																															1
																																? 4
																																: 0
																														}>
																														{
																															pPT4.title
																														}{' '}
																													</Box>
																												</SimTypography>
																											</AccordionSummary>
																											<AccordionDetails
																												sx={{
																													padding: 0
																												}}></AccordionDetails>
																										</Accordion>
																									</Grid>
																								) : (
																									<Grid
																										item
																										key={iPT4}
																										xs={12}>
																										<Button
																											size={
																												'large'
																											}
																											component={
																												'a'
																											}
																											href={
																												pPT4.href
																											}
																											fullWidth
																											sx={{
																												justifyContent:
																													'flex-start',
																												color:
																													activeLink ===
																													pPT4.href
																														? theme
																																.palette
																																.primary
																																.main
																														: theme
																																.palette
																																.text
																																.primary,
																												backgroundColor:
																													activeLink ===
																													pPT4.href
																														? alpha(
																																theme
																																	.palette
																																	.primary
																																	.main,
																																0.1
																														  )
																														: 'transparent',
																												fontWeight:
																													activeLink ===
																													pPT4.href
																														? 600
																														: 400
																											}}>
																											<SimTypography
																												variant={
																													'menuRootText'
																												}>
																												<Box
																													paddingLeft={
																														pPT4.isTabLink ===
																														1
																															? 4
																															: 0
																													}>
																													{
																														pPT4.title
																													}{' '}
																												</Box>
																											</SimTypography>
																										</Button>
																									</Grid>
																								)
																						)}
																					</Grid>
																				</AccordionDetails>
																			</Accordion>
																		</Grid>
																	) : (
																		<Grid item key={iPT3} xs={12}>
																			<Button
																				size={'large'}
																				component={'a'}
																				href={pPT3.href}
																				fullWidth
																				sx={{
																					justifyContent: 'flex-start',
																					color:
																						activeLink === pPT3.href
																							? theme.palette.primary.main
																							: theme.palette.text
																									.primary,
																					backgroundColor:
																						activeLink === pPT3.href
																							? alpha(
																									theme.palette
																										.primary.main,
																									0.1
																							  )
																							: 'transparent',
																					fontWeight:
																						activeLink === pPT3.href
																							? 600
																							: 400
																				}}>
																				<SimTypography variant={'menuRootText'}>
																					<Box
																						paddingLeft={
																							pPT3.isTabLink === 1 ? 3 : 0
																						}>
																						{pPT3.title}{' '}
																					</Box>
																				</SimTypography>
																			</Button>
																		</Grid>
																	)
																)}
															</Grid>
														</AccordionDetails>
													</Accordion>
												</Grid>
											) : (
												<Grid item key={iPT2} xs={12}>
													<Button
														size={'large'}
														component={'a'}
														href={pPT2.href}
														fullWidth
														sx={{
															justifyContent: 'flex-start',
															color:
																activeLink === pPT2.href
																	? theme.palette.primary.main
																	: theme.palette.text.primary,
															backgroundColor:
																activeLink === pPT2.href
																	? alpha(theme.palette.primary.main, 0.1)
																	: 'transparent',
															fontWeight: activeLink === pPT2.href ? 600 : 400
														}}>
														<SimTypography variant={'menuRootText'}>
															<Box paddingLeft={pPT2.isTabLink === 1 ? 2 : 0}>
																{pPT2.title}{' '}
															</Box>
														</SimTypography>
													</Button>
												</Grid>
											)
										)}
									</Grid>
								</AccordionDetails>
							</Accordion>
						</Grid>
					) : (
						<Grid item key={iPT} xs={12}>
							<Button
								size={'large'}
								component={'a'}
								href={pPT.href}
								fullWidth
								sx={{
									justifyContent: 'flex-start',
									backgroundColor:
										activeLink === pPT.href
											? alpha(theme.palette.primary.main, 0.1)
											: 'transparent',
									fontWeight: activeLink === pPT.href ? 600 : 400,
									color: hasActiveLink() ? 'primary' : 'text.primary'
								}}>
								<SimTypography variant={'menuRootText'}>
									<Box paddingLeft={pPT.isTabLink === 1 ? 1 : 0}> {pPT.title} </Box>
								</SimTypography>
							</Button>
						</Grid>
					)
				)}
			</Grid>
		</Box>
	);
};

NavItem.propTypes = {
	primeTabs: PropTypes.array,
	linkTreeFLAT: PropTypes.array.isRequired,
	title: PropTypes.string,
	onClose: PropTypes.func
};

export default NavItem;
